// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyState_wrapper__MJbsM"};